import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, createBlock as _createBlock, createSlots as _createSlots } from "vue"
import _imports_0 from '@/assets/img/data-empty.png'
import _imports_1 from '@/assets/img/icon/delete-box-red.svg'
import _imports_2 from '@/assets/img/modal-confirmation/conductor-save.svg'


const _hoisted_1 = { class: "plotting-form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between mb-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold" }, "Tambah Roster Pariwisata")
], -1)
const _hoisted_3 = { class: "flex gap-4" }
const _hoisted_4 = { class: "w-3/4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-3 px-4 py-3 mb-4 background-blue-primary rounded-lg" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle text-white" }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-white" }, "Khusus pariwisata, jika trayek gabungan, gunakan menu edit pada trayek utama")
], -1)
const _hoisted_6 = { class: "flex items-center justify-between mb-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-bold" }, "Tambah Roster Pariwisata"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal text-grey" }, "Pilih tanggal pariwisata")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Simpan'), -1)
const _hoisted_9 = { class: "flex items-center justify-between border-grey-2 rounded-lg px-4 py-3 mb-5" }
const _hoisted_10 = { class: "flex items-center gap-4" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "text-xl font-bold" }
const _hoisted_13 = { class: "border-grey-2 rounded-lg px-4 py-3" }
const _hoisted_14 = {
  key: 0,
  class: "flex items-center justify-center",
  style: {"min-height":"300px"}
}
const _hoisted_15 = { class: "flex flex-col items-center py-5" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-1/4 lg:w-full mx-auto",
    src: _imports_0
  })
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "text-md font-bold text-center mb-4" }, " Belum ada bus yang dimasukkan ke jadwal ", -1)
const _hoisted_18 = { class: "text-center w-full lg:w-2/3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary font-bold text-sm" }, "+ Tambah Bus", -1)
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "flex items-center justify-between mb-5" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-bold" }, "Tabel Roster Bus Pariwisata"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal text-grey" }, "Tabel dibawah merupakan roster bus untuk pariwisata")
], -1)
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Tambah'), -1)
const _hoisted_25 = {
  key: 0,
  class: "invalid-feedback mb-5"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-11 gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-3 text-sm font-bold text-grey required" }, "NOPOL"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-3 text-sm font-bold text-grey required" }, "KONDEKTUR"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold text-grey required" }, "SOPIR"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold text-grey" }, "PEMBANTU"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-center text-sm font-bold text-grey" }, "AKSI")
], -1)
const _hoisted_27 = { class: "col-span-3" }
const _hoisted_28 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_29 = { class: "col-span-3" }
const _hoisted_30 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_31 = { class: "col-span-2" }
const _hoisted_32 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_33 = { class: "col-span-2" }
const _hoisted_34 = { class: "flex items-center justify-center" }
const _hoisted_35 = {
  key: 0,
  src: _imports_1,
  alt: "delete",
  class: "cursor-not-allowed",
  style: {"width":"35px","height":"35px"}
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "w-1/4" }
const _hoisted_38 = {
  key: 0,
  class: "flex items-center justify-center",
  style: {"min-height":"500px"}
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col items-center py-5" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "w-3/4 lg:w-full mx-auto",
      src: _imports_2
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-bold text-center" }, " Informasi Bus "),
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal text-center mb-5 w-full lg:w-2/3" }, " Klik tambah dan pilih bus atau klik area pada PP untuk memunculkan informasi bus ")
], -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "mb-5" }
const _hoisted_43 = { class: "text-2xl font-bold" }
const _hoisted_44 = { class: "text-base font-normal text-grey" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal mb-4" }, "Informasi Bus", -1)
const _hoisted_46 = { class: "grid grid-cols-2 gap-4 mb-2" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal text-grey" }, "No Lambung", -1)
const _hoisted_48 = { class: "text-sm font-normal text-right" }
const _hoisted_49 = { class: "grid grid-cols-2 gap-4 mb-2" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal text-grey" }, "No. Polisi", -1)
const _hoisted_51 = { class: "text-sm font-normal text-right" }
const _hoisted_52 = { class: "grid grid-cols-2 gap-4 mb-2" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal text-grey" }, "Tahun Pembuatan", -1)
const _hoisted_54 = { class: "text-sm font-normal text-right" }
const _hoisted_55 = { class: "grid grid-cols-2 gap-4 mb-2" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal text-grey" }, "Type/Karoseri", -1)
const _hoisted_57 = { class: "text-sm font-normal text-right" }
const _hoisted_58 = { class: "grid grid-cols-2 gap-4 mb-2" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-normal text-grey" }, "Warna", -1)
const _hoisted_60 = { class: "text-sm font-normal text-right" }
const _hoisted_61 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "node" })
], -1)
const _hoisted_63 = { class: "" }
const _hoisted_64 = { class: "timeline-title text-sm font-normal text-grey" }
const _hoisted_65 = { class: "timeline-desc text-sm font-normal text-grey" }
const _hoisted_66 = {
  class: "w-full my-4",
  style: {"height":"150px","max-height":"200px","overflow-y":"auto"}
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "w-full grid grid-cols-2 gap-2 mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center text-grey text-base font-bold" }, "Nopol"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-center text-grey text-base font-bold" }, "PP")
], -1)
const _hoisted_68 = { class: "text-center text-grey text-base font-normal" }
const _hoisted_69 = { class: "text-center text-grey text-base font-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_SelectFetch = _resolveComponent("SelectFetch")!
  const _component_Field = _resolveComponent("Field")!
  const _component_FieldArray = _resolveComponent("FieldArray")!
  const _component_Card = _resolveComponent("Card")!
  const _component_HjpTabView = _resolveComponent("HjpTabView")!
  const _component_Form = _resolveComponent("Form")!
  const _component_PariwisataRosterDialog = _resolveComponent("PariwisataRosterDialog")!
  const _component_HjpCofirmModal = _resolveComponent("HjpCofirmModal")!
  const _component_HjpAlertModal = _resolveComponent("HjpAlertModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Form, {
          key: 0,
          onSubmit: _ctx.onSubmit,
          "validation-schema": _ctx.schema,
          "initial-values": _ctx.initialValue,
          class: "form-container",
          validateOnMount: true
        }, {
          default: _withCtx(({ errors, values, setFieldValue, meta }) => [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_Card, { class: "card-no-shadow wrap-hjp-data-table" }, {
                  content: _withCtx(() => [
                    _hoisted_5,
                    _createElementVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("div", null, [
                        _createVNode(_component_Button, {
                          class: "mb-2 sm:mb-0 flex gap-2",
                          type: "submit",
                          disabled: !_ctx.showForm
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", null, [
                          _createElementVNode("img", {
                            class: "self-baseline",
                            src: require('@/assets/img/icon/calendar-outline-black.svg'),
                            style: {"min-width":"25px","height":"25px"},
                            alt: ""
                          }, null, 8, _hoisted_11)
                        ]),
                        _createElementVNode("div", _hoisted_12, _toDisplayString(`${_ctx.moment(_ctx.store.state.roster.dateRange.start.toString()).format('DD MMMM YYYY')} - ${_ctx.moment(_ctx.store.state.roster.dateRange.end.toString()).format('DD MMMM YYYY')}`), 1)
                      ]),
                      _createElementVNode("div", {
                        class: "text-primary text-base font-semibold cursor-pointer",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openFormDialog && _ctx.openFormDialog(...args)))
                      }, "Ganti Jadwal")
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      (!_ctx.showForm)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _hoisted_16,
                              _hoisted_17,
                              _createElementVNode("div", _hoisted_18, [
                                _createVNode(_component_Button, {
                                  class: "w-full extra-submit-button mb-2 sm:mb-0 flex gap-4",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showFormField()))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_19
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createVNode(_component_FieldArray, { name: "data" }, {
                              default: _withCtx(({ fields, push, remove, prepend }) => [
                                _createElementVNode("div", _hoisted_21, [
                                  _hoisted_22,
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_Button, {
                                      class: "flex gap-2",
                                      onClick: ($event: any) => (prepend(_ctx.defaultValue))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", {
                                          innerHTML: _ctx.icon.svg.plusEva
                                        }, null, 8, _hoisted_23),
                                        _hoisted_24
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ]),
                                (meta.touched)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(errors['data']), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", null, [
                                  _hoisted_26,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields, (dataX, indexX) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: indexX,
                                      class: "grid grid-cols-11 gap-4 pb-1 mb-3"
                                    }, [
                                      _createElementVNode("div", _hoisted_27, [
                                        _createVNode(_component_Field, {
                                          id: `data[${indexX}].vehicle`,
                                          name: `data[${indexX}].vehicle`
                                        }, {
                                          default: _withCtx(({ field, handleChange, handleBlur }) => [
                                            _createVNode(_component_SelectFetch, _mergeProps(field, {
                                              modelValue: field.value,
                                              id: `nopol-${indexX}`,
                                              "input-id": "class-input",
                                              endpoint: "/management/v1/MsVehicle",
                                              searchCustom: [['activeOnly', '=', true], ['isHasTrayek', '=', true], ['orderByHasTrayek', '=', false]],
                                              fieldLabel: (v) => v.Nopol,
                                              classname: 'custom-select',
                                              placeholder: 'Pilih Bus',
                                              clearable: false,
                                              searchFields: ['Nopol'],
                                              onChange: (v) => _ctx.setCurrVehicleInfo(v, indexX),
                                              "onSearch:focus": ($event: any) => (_ctx.setCurrVehicleInfo(values.data[indexX].vehicle, indexX))
                                            }), null, 16, ["modelValue", "id", "fieldLabel", "onChange", "onSearch:focus"])
                                          ]),
                                          _: 2
                                        }, 1032, ["id", "name"]),
                                        (meta.touched)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(errors[`data[${indexX}].vehicle`]), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_29, [
                                        _createVNode(_component_Field, {
                                          id: `data[${indexX}].kondektur`,
                                          name: `data[${indexX}].kondektur`
                                        }, {
                                          default: _withCtx(({ field, handleChange, handleBlur }) => [
                                            _createVNode(_component_SelectFetch, _mergeProps(field, {
                                              modelValue: field.value,
                                              id: `kondektur-${indexX}`,
                                              "input-id": "class-input",
                                              endpoint: "/management/v1/User/all-user",
                                              searchCustom: [['activeOnly', '=', true], ['roles', '=', 'Condectur']],
                                              fieldLabel: (v) => v.Fullname,
                                              "onUpdate:modelValue": _ctx.onUpdateCondectur,
                                              "onSearch:focus": ($event: any) => (_ctx.setCurrVehicleInfo(values.data[indexX].vehicle, indexX)),
                                              placeholder: 'Pilih Kondektur',
                                              clearable: false,
                                              searchFields: ['Fullname'],
                                              classname: 'custom-select'
                                            }), null, 16, ["modelValue", "id", "fieldLabel", "onUpdate:modelValue", "onSearch:focus"])
                                          ]),
                                          _: 2
                                        }, 1032, ["id", "name"]),
                                        (meta.touched)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(errors[`data[${indexX}].kondektur`]), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_31, [
                                        _createVNode(_component_Field, {
                                          id: `data[${indexX}].driver`,
                                          name: `data[${indexX}].driver`
                                        }, {
                                          default: _withCtx(({ field, handleChange, handleBlur }) => [
                                            _createVNode(_component_SelectFetch, _mergeProps(field, {
                                              modelValue: field.value,
                                              id: `sopir-${indexX}`,
                                              "input-id": "class-input",
                                              endpoint: "/management/v1/User/all-user",
                                              searchCustom: [['activeOnly', '=', true], ['roles', '=', 'Driver']],
                                              fieldLabel: (v) => v.Fullname,
                                              "onUpdate:modelValue": _ctx.onUpdateDriver,
                                              "onSearch:focus": ($event: any) => (_ctx.setCurrVehicleInfo(values.data[indexX].vehicle, indexX)),
                                              placeholder: 'Pilih Sopir',
                                              clearable: false,
                                              searchFields: ['Fullname'],
                                              classname: 'custom-select'
                                            }), null, 16, ["modelValue", "id", "fieldLabel", "onUpdate:modelValue", "onSearch:focus"])
                                          ]),
                                          _: 2
                                        }, 1032, ["id", "name"]),
                                        (meta.touched)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(errors[`data[${indexX}].driver`]), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_33, [
                                        _createVNode(_component_Field, {
                                          id: `data[${indexX}].helper`,
                                          name: `data[${indexX}].helper`
                                        }, {
                                          default: _withCtx(({ field, handleChange, handleBlur }) => [
                                            _createVNode(_component_SelectFetch, _mergeProps(field, {
                                              modelValue: field.value,
                                              id: `pembantu-${indexX}`,
                                              "input-id": "class-input",
                                              endpoint: "/management/v1/User/all-user",
                                              searchCustom: [['activeOnly', '=', true], ['roles', '=', 'Helper']],
                                              fieldLabel: (v) => v.Fullname,
                                              "onSearch:focus": ($event: any) => (_ctx.setCurrVehicleInfo(values.data[indexX].vehicle, indexX)),
                                              placeholder: 'Pilih Pembantu',
                                              clearable: false,
                                              searchFields: ['Fullname'],
                                              classname: 'custom-select'
                                            }), null, 16, ["modelValue", "id", "fieldLabel", "onSearch:focus"])
                                          ]),
                                          _: 2
                                        }, 1032, ["id", "name"])
                                      ]),
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_34, [
                                          (fields.length === 1)
                                            ? (_openBlock(), _createElementBlock("img", _hoisted_35))
                                            : (_openBlock(), _createElementBlock("img", {
                                                key: 1,
                                                src: _imports_1,
                                                alt: "delete",
                                                class: "cursor-pointer",
                                                style: {"width":"35px","height":"35px"},
                                                onClick: ($event: any) => (remove(indexX))
                                              }, null, 8, _hoisted_36))
                                        ])
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_Card, { class: "card-no-shadow wrap-hjp-data-list trayek-right-panel" }, {
                  content: _withCtx(() => [
                    (!_ctx.selectedBus)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40))
                      : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.selectedBus.HullNumber ?? '-'), 1),
                            _createElementVNode("div", _hoisted_44, _toDisplayString(`${_ctx.selectedBus.Nopol ?? '-'} (${_ctx.selectedBus.PurchasedAt ?? '-'})`), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_45,
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_46, [
                                _hoisted_47,
                                _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.selectedBus.HullNumber ?? '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_49, [
                                _hoisted_50,
                                _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.selectedBus.Nopol ?? '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_52, [
                                _hoisted_53,
                                _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.selectedBus.PurchasedAt ?? '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_55, [
                                _hoisted_56,
                                _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.selectedBus.Type ?? '-'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_58, [
                                _hoisted_59,
                                _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.selectedBus.Colours ?? '-'), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createVNode(_component_HjpTabView, {
                              class: "trayek-select-bus",
                              tabHeader: _ctx.tabHeader,
                              onTabsChange: _ctx.tabsChange
                            }, null, 8, ["tabHeader", "onTabsChange"]),
                            (_ctx.activeTab === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logBus, (data, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: index,
                                          class: "timeline pb-5"
                                        }, [
                                          _hoisted_62,
                                          _createElementVNode("div", _hoisted_63, [
                                            _createElementVNode("div", _hoisted_64, _toDisplayString(`${_ctx.moment(data.CreatedAt.toString()).format('DD MMMM YYYY')} - ${_ctx.moment(data.CreatedAt.toString()).format('HH:mm')}`), 1),
                                            _createElementVNode("div", _hoisted_65, _toDisplayString(data.UpdatedString), 1)
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema", "initial-values"]))
      : _createCommentVNode("", true),
    (_ctx.store.state?.headerButton.isShowDialogForm)
      ? (_openBlock(), _createBlock(_component_PariwisataRosterDialog, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_HjpCofirmModal, {
      show: _ctx.showConfirmDialog,
      title: _ctx.confirmDialog?.title,
      subTitle: _ctx.confirmDialog?.subTitle,
      btnSubmitTitle: _ctx.confirmDialog?.btnSubmitTitle,
      imgContent: _ctx.confirmDialog.imgContent,
      onHideDialog: _ctx.hideDialogConfirmation,
      onOnSubmit: _ctx.submitFromDialog
    }, null, 8, ["show", "title", "subTitle", "btnSubmitTitle", "imgContent", "onHideDialog", "onOnSubmit"]),
    _createVNode(_component_HjpAlertModal, {
      show: _ctx.modalConfirmation.show,
      title: _ctx.modalConfirmation.title,
      subTitle: _ctx.modalConfirmation.subTitle,
      subTitleHtml: _ctx.modalConfirmation.subTitleHtml,
      btnSubmitTitle: _ctx.modalConfirmation.btnSubmitTitle,
      imgContent: _ctx.modalConfirmation.imgContent,
      onHideDialog: _ctx.hideConfirmDialog,
      onOnSubmit: _ctx.hideConfirmDialog
    }, _createSlots({ _: 2 }, [
      (_ctx.currentSchedules.length > 0)
        ? {
            name: "additionalContent",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_66, [
                _hoisted_67,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentSchedules, (data) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: data,
                    class: "w-full grid grid-cols-2 gap-2 mb-2"
                  }, [
                    _createElementVNode("div", _hoisted_68, _toDisplayString(data.RegNumber), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_69, _toDisplayString(`PP${data.PpOrder} (${data.DepartureTime})`), 1)
                    ])
                  ]))
                }), 128))
              ])
            ])
          }
        : undefined
    ]), 1032, ["show", "title", "subTitle", "subTitleHtml", "btnSubmitTitle", "imgContent", "onHideDialog", "onOnSubmit"])
  ]))
}